import useReceiptCustomisationStore from "../../stores/receipt-customisation/receipt-customisation-store";
import { TPosition } from "../../stores/receipt-customisation/types";
import NumberStepInputComponent from "./number-step-input-component";

const MarginInput = ({
  value,
  position,
  onChange,
  suffix,
}: {
  value: number;
  position: TPosition;
  onChange: ({
    position,
    newValue,
  }: {
    position: TPosition;
    newValue: number;
  }) => void;
  suffix: string;
}) => {
  return (
    <div className="flex justify-between items-center">
      {/* Body/Body 1/Regular */}
      <div className="text-14 font-400 leading-6 capitalize">{position}</div>
      <NumberStepInputComponent
        value={value.toString() || ""}
        onValueChange={(e) =>
          onChange({ position, newValue: Number(e.target.value) })
        }
        suffix={suffix}
      />
    </div>
  );
};

const MarginsComponent = () => {
  const { margin, setMargin } = useReceiptCustomisationStore();
  const { top, left, right, bottom } = margin;

  const handleMarginChange = ({
    position,
    newValue,
  }: {
    position: TPosition;
    newValue: number;
  }) => {
    setMargin({
      [position]: newValue,
    });
  };

  return (
    <div className="p-16">
      <div className="w-full flex items-center text-16 font-700 leading-8">
        Margins
      </div>
      <div className="space-y-8 pt-8">
        <MarginInput
          value={top}
          position="top"
          suffix="cm"
          onChange={handleMarginChange}
        />
        <MarginInput
          value={left}
          position="left"
          suffix="cm"
          onChange={handleMarginChange}
        />
        <MarginInput
          value={right}
          position="right"
          suffix="cm"
          onChange={handleMarginChange}
        />
        <MarginInput
          value={bottom}
          position="bottom"
          suffix="cm"
          onChange={handleMarginChange}
        />
      </div>
    </div>
  );
};

export default MarginsComponent;
